import APIKit from "../Allapis/Apikit/apikit";

export const getDairiesServer = async (id) => {
  const endpoint = id ? `/admin/dates/${id}` : `/admin/dates`;
  const res = await APIKit.get(endpoint);
  console.log("Getresponse6", res.data);
  return res.data;
};

export const updateDairiesServer = async (id, values) => {
  const res = await APIKit.put(`/admin/dates/${id}`, values);
  console.log({ resupdate: res });
  return res.data;
};

export const createAndUpdateDairiesServer = async (id, values) => {
  let res;
  if (id) {
    res = await APIKit.post(`/admin/dates/${id}`, values);
  } else {
    res = await APIKit.post(`/admin/dates`, values);
  }
  return res.data;
};

export const deleteDairiesServer = async (del_id) => {
  console.log("del_id");
  const res = await APIKit.put(`/admin/dates/${del_id}`);
  console.log({ resdelete: res });
  return res.data;
};
